import { PaymentAPI as i } from "./paymentApi.js";
import { PaymentGatewayError as y } from "./paymentGatewayError.js";
function n(s) {
  return {
    item_id: s.itemId,
    quantity: s.quantity,
    total: s.total,
    item_price: s.itemPrice
  };
}
var c;
((s) => {
  class d {
    constructor(e, a) {
      this.gatewayUrl = e, this.gatewayToken = a;
    }
    async process(e) {
      const a = await fetch(`${this.gatewayUrl}/api/v1/process-payment/`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          ...this.gatewayToken ? {
            authorization: `Token ${this.gatewayToken}`
          } : {}
        },
        body: JSON.stringify({
          payment_method_id: e.paymentMethodId,
          location_id: e.locationId,
          currency: e.currency,
          order_id: e.orderId,
          loyalty_id: e.loyaltyId,
          email: e.email,
          external_user_id: e.externalUserId,
          tip: e.tip,
          cashback_amount: e.cashback,
          amount: e.amount,
          payment_methods: e.paymentMethods.map((t) => ({
            engine_type: t.engine,
            method_type: t.methodType
          })),
          ws_uuid: e.wsUuid,
          shop_url: e.shopUrl,
          selected_items: (e.selectedItems ?? []).map(n),
          actions: e.actions,
          payment_method_data: e.paymentMethodData,
          store_payment_method: e.storePaymentMethod,
          country_code: e.countryCode,
          shop_order_source: e.shopOrderSource
        })
      });
      if (a.status !== 200)
        throw new Error("Could not process payment");
      const o = await a.json();
      return {
        status: o.status,
        code: o.code,
        action: o.action,
        trackingUrl: o.tracking_url,
        challengeUrl: o.challenge_url,
        transactionId: o.transaction_id
      };
    }
    async confirmProcessPayment(e) {
      const a = await fetch(`${this.gatewayUrl}/api/v1/confirm-process-payment/`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          ...this.gatewayToken ? {
            authorization: `Token ${this.gatewayToken}`
          } : {}
        },
        body: JSON.stringify({
          payment_method_id: e.paymentMethodId,
          location_id: e.locationId,
          currency: e.currency,
          order_id: e.orderId,
          loyalty_id: e.loyaltyId,
          email: e.email,
          external_user_id: e.externalUserId,
          phone_number: e.phoneNumber,
          user_full_name: e.userFullName,
          tip: e.tip,
          cashback_amount: e.cashback,
          amount: e.amount,
          ws_uuid: e.wsUuid,
          shop_url: e.shopUrl,
          selected_items: (e.selectedItems ?? []).map(n),
          actions: e.actions,
          payment_method_data: e.paymentMethodData,
          payment_methods: e.paymentMethods.map((t) => ({
            engine_type: t.engine,
            method_type: t.methodType
          })),
          store_payment_method: e.storePaymentMethod,
          country_code: e.countryCode,
          shop_order_source: e.shopOrderSource
        })
      });
      if (a.status !== 200)
        throw new Error("Could not confirm payment");
      const o = await a.json();
      return {
        status: o.status,
        code: o.code,
        action: o.action,
        trackingUrl: o.tracking_url,
        challengeUrl: o.challenge_url,
        transactionId: o.transaction_id
      };
    }
    async redsysCheckout(e) {
      var t;
      const a = await fetch(`${this.gatewayUrl}/api/v1/redsys/checkout/`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          ...this.gatewayToken ? {
            authorization: `Token ${this.gatewayToken}`
          } : {}
        },
        body: JSON.stringify({
          order_id: e.orderId,
          amount: e.amount,
          cashback_amount: e.cashback,
          external_user_id: e.externalUserId,
          tip: e.tip,
          currency: e.currency,
          location_id: e.locationId,
          return_url: e.returnUrl,
          email: e.email,
          country_code: e.countryCode,
          actions: e.actions,
          // Pay-at-table only: the Shop checkout carries neither, and Pay's proxy
          // rejects a blank ws_uuid — so send them only when the intent has them.
          ...e.wsUuid ? { ws_uuid: e.wsUuid } : {},
          ...(t = e.selectedItems) != null && t.length ? { selected_items: e.selectedItems.map(n) } : {}
        })
      });
      if (a.status !== 200) {
        const r = await a.json().catch(() => null);
        throw new y("Could not initiate Redsys checkout", r == null ? void 0 : r.code);
      }
      const o = await a.json();
      return {
        transactionCode: o.transaction_code,
        action: o.action
      };
    }
    async validatePaymentTransaction(e) {
      const a = await fetch(`${this.gatewayUrl}/api/v1/payment-transaction/validate/`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          ...this.gatewayToken ? {
            authorization: `Token ${this.gatewayToken}`
          } : {}
        },
        body: JSON.stringify({
          shop_order_id: e.shopOrderId,
          ws_uuid: e.wsUuid,
          engine_type: e.engineType
        })
      });
      if (a.status !== 200)
        throw new Error("Could not validate payment");
      return a.json();
    }
    async initProcessPayment(e) {
      const a = await fetch(`${this.gatewayUrl}/api/v1/init-process-payment/`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          ...this.gatewayToken ? {
            authorization: `Token ${this.gatewayToken}`
          } : {}
        },
        body: JSON.stringify({
          location_id: e.locationId,
          payment_methods: [{
            engine_type: e.engineType,
            method_type: e.methodType,
            channel: e.channel
          }]
        })
      });
      if (a.status !== 200)
        throw new Error("Could not init payment");
      const o = await a.json();
      return {
        configuration: {
          statementDescriptor: o.configuration.statement_descriptor,
          countryCode: o.configuration.country_code
        }
      };
    }
    async disablePaymentMethod(e) {
      const a = i.engineToString(e.engineType);
      if ((await fetch(`${this.gatewayUrl}/${a}/tokenization/disable/`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          ...this.gatewayToken ? {
            authorization: `Token ${this.gatewayToken}`
          } : {}
        },
        body: JSON.stringify({
          engine_type: e.engineType,
          shop_id: e.shopId,
          location_id: e.locationId,
          email: e.payerId,
          store_payment_method_id: e.storePaymentMethodId
        })
      })).status !== 200)
        throw new Error("Could not disable payment method");
    }
  }
  s.PaymentRespository = d;
})(c || (c = {}));
export {
  c as PaymentRequests
};
//# sourceMappingURL=paymentRequests.js.map
